import { Typography } from "@mui/material"

interface TitleValueDisplayProps {
    title: string,
    value?: string | Date
}

function TitleValueDisplay(props: TitleValueDisplayProps) {
    const { title, value } = props

    const text = value instanceof Date
        ? value.toLocaleDateString()
        : value

    return (
        <div>
            <Typography variant="body1" gutterBottom color="text.secondary">{ title }</Typography>
            <Typography variant="body2" color="text.primary">{ text || `-` }</Typography>
        </div>
    )
}

export default TitleValueDisplay